import { render, staticRenderFns } from "./ChatConversation.vue?vue&type=template&id=5acc8112&scoped=true"
import script from "./ChatConversation.vue?vue&type=script&lang=ts"
export * from "./ChatConversation.vue?vue&type=script&lang=ts"
import style0 from "./ChatConversation.vue?vue&type=style&index=0&id=5acc8112&scoped=true&lang=css"
import style1 from "./ChatConversation.vue?vue&type=style&index=1&id=5acc8112&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5acc8112",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5acc8112')) {
      api.createRecord('5acc8112', component.options)
    } else {
      api.reload('5acc8112', component.options)
    }
    module.hot.accept("./ChatConversation.vue?vue&type=template&id=5acc8112&scoped=true", function () {
      api.rerender('5acc8112', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chat/ChatConversation.vue"
export default component.exports